module.exports = __webpack_public_path__ + "img/hint.09aa5029.png";